// DS1.7.1
import React from 'react';
import c from 'classnames';
import s from './NotificationCounter.scss';

export interface Props {
  color?: 'green' | 'red';
  className?: string;
  children: React.ReactNode;
}

const NotificationCounter: React.FC<Props> = ({ children, color = 'red', className }) => (
  <div className={c(s['root'], s[`color-${color}`], className)}>{children}</div>
);
NotificationCounter.displayName = 'NotificationCounter';

export default NotificationCounter;
